import { gql } from '@apollo/client';

type DateTime = string;
type Json = unknown;

export type UsersMeSupplierTier2 = {
  sys_name: string;
  name: string;
};

export type UsersMeSalesforceSupplier = {
  uuid: string;
  supplier_id: string;
  salesforce_lead_id: string | null;
  salesforce_account_id: string | null;
  approval_state: string;
  public_approval_state: string;
  created: DateTime;
  updated: DateTime;
};

export type UsersMeSupplierUser = {
  uuid: string;
  supplier_id: string;
  user_id: string;
  created: DateTime | null;
  updated: DateTime | null;
};

export type UsersMeSupplier = {
  uuid: string;
  name: string | null;
  state: string | null;
  public_events_visible: boolean;
  slug: string | null;
  category_tier1: string | null;
  commission: number | null;
  visible: boolean;
  trusted: boolean;
  algorithm_discoverable: boolean;
  profile_picture: Json | null;
  supplier_images: Json | null;
  images: Json[] | null;
  tier2: UsersMeSupplierTier2[];
  salesforce_suppliers: UsersMeSalesforceSupplier | null;
  suppliersUsers: UsersMeSupplierUser;
};

export type UsersMePaymentProvider = {
  name: string;
  id: string | null;
};

export type UsersMeLinks = {
  self: string;
};

export type UsersMeState = {
  tandc: boolean | null;
  lastLogin: DateTime | null;
  created: DateTime | null;
  updated: DateTime | null;
};

export type UsersMeFavourite = {
  uuid: string;
};

export type UsersMe = {
  id: string;
  email: string;
  type: string | null;
  firstName: string;
  lastName: string;
  phone: string | null;
  customerId: string | null;
  reset_token: string | null;
  smsNotifications: boolean | null;
  role: string | null;
  isLgbtq: string | null;
  ethnic_origin: string | null;
  gender: string | null;
  segment: string | null;
  business_user: boolean | null;
  heardAboutUs: string | null;
  accountClosedAt: DateTime | null;
  links: UsersMeLinks;
  paymentProvider: UsersMePaymentProvider;
  state: UsersMeState;
  suppliers: UsersMeSupplier[];
  favourites: UsersMeFavourite[];
};

export type UsersMeQueryResponse = {
  usersMe: UsersMe;
};

export const USERS_ME = gql`
  query UsersMe {
    usersMe {
      id
      email
      type
      firstName
      lastName
      phone
      customerId
      reset_token
      smsNotifications
      role
      isLgbtq
      ethnic_origin
      gender
      segment
      business_user
      heardAboutUs
      accountClosedAt
      paymentProvider {
        name
        id
      }
      state {
        tandc
        lastLogin
        created
        updated
      }
      favourites {
        uuid
      }
      suppliers {
        uuid
        name
        state
        public_events_visible
        slug
        category_tier1
        commission
        visible
        trusted
        algorithm_discoverable
        profile_picture
        supplier_images
        images
        tier2 {
          name
          sys_name
        }
        salesforce_suppliers {
          uuid
          supplier_id
          salesforce_lead_id
          salesforce_account_id
          approval_state
          public_approval_state
          created
          updated
        }
        suppliersUsers {
          uuid
          supplier_id
          user_id
          created
          updated
        }
      }
      links {
        self
      }
    }
  }
`;
